export enum AppToggle {
    DISPLAY_DATE_RANGE = 'mosaic.display-date-range', // Turn on to display the date range in the top banner.
    DOWNLOAD_SAMPLE_CSV = 'mosaic.download-sample-csv', // Turn on ability to download the detailed items as CSV file.
    EXECUTIVE_SUMMARY_WIDGET = 'mosaic.executive-summary', // Turn on to display MosAIc executive summary for cluster using generative answer.
    CLUSTER_ITEMS_SORTING = 'mosaic.items_sort_by_option', // Turn on ability to sort cluster items by a given field.
}
